import albumServices from '../../services/album';
import Album from '../../model/album';

export const state = {
    albums: [],
}

export const mutations = {
    setAlbums(state, albums) {
        state.albums = albums
    }
}

export const getters = {
    getAlbums(state) {
        return state.albums.map((p)=>new Album(p))
    },
}

export const actions = {
    getAll({commit}, data = {}){
        return albumServices.getAll(data)
        .then((response)=>{
            commit('setAlbums', response.data.data)
            return response
        })
    },
}